import { LoadingController, NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Platform } from '@ionic/angular';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { platform } from 'os';
import { LanguageService } from './services/language/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(
    private router: Router,
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private plateform : Platform,
    private language: LanguageService,
    translate: TranslateService
  ) {

    // this.language.initLanguage();
    localStorage.removeItem('configuration');
    localStorage.removeItem('menu');
    // console.log("aaaaaaaaaaaa");

    // if(localStorage.getItem("loglevel") != undefined){
    //   localStorage.clear();
    // }
    this.language.initLanguage();
  
    translate.addLangs(this.language.availableLanguage);
    translate.setDefaultLang(this.language.userLanguage);
    // translate.use(this.language.userLanguage);
    translate.use("fr");

    this.language.currentLanguage.subscribe((lang)=>{
      translate.setDefaultLang(this.language.userLanguage);
      translate.use(this.language.userLanguage);
    });


    localStorage.removeItem('head1');
    localStorage.removeItem('head2');


    document.addEventListener('ionBackButton', (ev) => {
      this.navCtrl.back();
    });



    console.log('--------------------------')
    // console.log(this.plateform.is('cordova'))
    if (this.plateform.is('cordova')) {

      StatusBar.setBackgroundColor({ color: '#cad6fc' });

      window.addEventListener('offline', () => {
        StatusBar.setBackgroundColor({ color: '#e0e4f380' });
        // console.log('offline')
        // this.showLoading();

        this.navCtrl.navigateRoot('/network');
      });


      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      });

      // On success, we should be able to receive notifications
      PushNotifications.addListener('registration',
        (token: Token) => {
          // alert('Push registration success, token: ' + token.value);
          localStorage.setItem('fcmToken', token.value)
          // alert(token.value)
        }
      );

      // Some issue with our setup and push will not work
      PushNotifications.addListener('registrationError',
        (error: any) => {
          // alert('Error on registration: ' + JSON.stringify(error));
        }
      );

      // Show us the notification payload if the app is open on our device
      PushNotifications.addListener('pushNotificationReceived',
        (notification: PushNotificationSchema) => {
          // alert('Push received: ' + JSON.stringify(notification));
        }
      );

      // Method called when tapping on a notification
      PushNotifications.addListener('pushNotificationActionPerformed',
        (notification: ActionPerformed) => {
          // alert('Push action performed: ' + JSON.stringify(notification));
          if(notification?.notification?.data?.link == "cartRecover"){
            this.navCtrl.navigateRoot('/panier/'+notification?.notification?.data?.href);
          }
        }
      );

    }
  }

  handleRefresh() {
    this.router.navigateByUrl('/refresh').then(() => {
      this.navCtrl.back();
    });
  }


  // async showLoading() {
  //   const loading = await this.loadingCtrl.create({
  //     message: 'En attente de connexion',
  //   });

  //   loading.present();
  // }

}
